import { configureStore } from '@reduxjs/toolkit';
import { getPersistConfig } from 'redux-deep-persist';
import { createEpicMiddleware } from 'redux-observable';
import {
  FLUSH, PAUSE,
  PERSIST, persistReducer, PURGE,
  REGISTER, REHYDRATE
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import epics from '../epics';
import rootReducer from '../reducers';

const persistConfig = getPersistConfig({
  key: 'root',
  storage,
  whitelist: ['common.phoneNumberList', 'common.memberIdList'],
  rootReducer
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

const epicMiddleware = createEpicMiddleware();

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
    },
  }).concat(epicMiddleware),
});

epicMiddleware.run(epics);

export default store;